import { FirestoreDoc } from "@p0security/frontend-core/react";
import { PermissionRequest } from "@p0security/shared/types/permission";
import { Flex } from "@p0security/ui";

import { RequestExport } from "./RequestHistoryExport";
import { RequestSearch } from "./RequestHistorySearch";

export const SearchBar: React.FC<{
  onChange: (value: string | null) => void;
  requests?: FirestoreDoc<PermissionRequest>[];
  searchQuery: string | null;
  hideExport?: boolean;
}> = ({ onChange, requests, searchQuery, hideExport }) => {
  return (
    <Flex className="w-full max-w-[85vw]" gap={8} justify="flex-end">
      <RequestSearch onInputChange={onChange} searchQuery={searchQuery} />
      {!hideExport && <RequestExport requests={requests ?? []} />}
    </Flex>
  );
};
